module.exports = __webpack_public_path__ + "img/find-doctors-card.3460bce4.png";